/* eslint-disable */
import HttpClient from "../../shared-module/utilities/http-client";

const { ProtectedHttpClient } = HttpClient;

/**
 endpoints to schedule messages
    ScheduleEmail: [POST] /api/schedule/email
    ScheduleIVR: [POST]/api/schedule/ivr
    ScheduleSMS: [POST] /api/schedule/sms
    ListScheduleEmail: [POST] /api/schedule/email/list
    ListScheduleIVR: [POST] /api/schedule/ivr/list
    ListScheduleSMS: [POST] /api/schedule/sms/list
    DeleteScheduleEmail: [DELETE] /api/schedule/email/delete/{id}
    DeleteScheduleIVR: [DELETE] /api/schedule/ivr/delete/{id}
    DeleteScheduleSMS: [DELETE] /api/sms/schedule/delete/{id}
 */
const SMSApi = {
  public: {},
  private: {
    /**
     *  To send bulk sms
     */
    sendBulk: payload => ProtectedHttpClient.post(`sms/masssend`, payload),
    /**
     *  To create a new automated message (schedule)
     */
    schedule: payload => ProtectedHttpClient.post(`/schedule/sms`, payload),
    /**
     *  To fetch all schduled sms
     */
    fetchScheduledList: (payload) => ProtectedHttpClient.post(`/schedule/list`, payload),
    /**
     *  To edit an automated message (schedule)
     */
    updateScheduledMessage: payload => ProtectedHttpClient.post(`/schedule/sms`, payload),
    /**
     *  To delete an automated message (schedule)
     */
    deleteScheduledMessage: id => ProtectedHttpClient.delete(`/schedule/delete/${id}`),
    /**
     *  To toggle pause of an automated sms (schedule)
     */
     togglePause: (id, payload) => ProtectedHttpClient.put(`/schedule/pause/${id}`, payload),
     
     editScheduledMessage: (payload, id) => ProtectedHttpClient.put(`/schedule/update/${id}`, payload),
  }
};
export default SMSApi;
